import {ColorSet} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/color.types';

/**
 * Normalizes a backend `ColorSet` {backgroundColor, foregroundColor} pair into
 * plain hex strings, treating an empty hex (the generated codec's value when
 * the backend omits the field) as absent.
 *
 * Each call site historically resolved this slightly differently (a legacy
 * hex fallback, `|| undefined`, `|| null`, or no fallback at all). The
 * `backgroundFallback` / `foregroundFallback` params let each site keep its
 * own exact fallback behaviour instead of unifying it. See ASFE-14225.
 */
export const getColorSetHexes = <
  BackgroundFallback extends string | null | undefined = undefined,
  ForegroundFallback extends string | null | undefined = undefined,
>(
  colors: ColorSet,
  {
    backgroundFallback,
    foregroundFallback,
  }: {
    backgroundFallback?: BackgroundFallback;
    foregroundFallback?: ForegroundFallback;
  } = {},
): {
  backgroundColor: string | BackgroundFallback;
  foregroundColor: string | ForegroundFallback;
} => ({
  backgroundColor:
    colors.backgroundColor.hex || (backgroundFallback as BackgroundFallback),
  foregroundColor:
    colors.foregroundColor.hex || (foregroundFallback as ForegroundFallback),
});
